export enum RewardType {
  CUSTOMER_SERVICE_EXTENSION = 'CUSTOMER_SERVICE_EXTENSION',
  PRODUCT_DISCOUNT = 'PRODUCT_DISCOUNT',
}
